import React from 'react';
import styled from 'styled-components';
import Checkbox from '@commoncomponents/frontend-components/dist/components/Checkbox';
const Wrapper = styled.div `
  display: flex;
  justify-content: center;
  margin-left: -10px;
  label {
    margin: auto !important;
  }
`;
const CheckBox = ({ checked, onClick }) => (React.createElement(Wrapper, null,
    React.createElement(Checkbox, { required: false, checked: checked, onChange: onClick, disabled: false, name: 'checkbox', label: '', indeterminate: false })));
export default CheckBox;
